<template>
  <ErrorMessage
    type="warning"
    :title="title"
    :description="description"
    :show-retry="showRetry"
    :retry-text="retryText"
    @retry="handleRetry"
  />
</template>

<script>
import ErrorMessage from './ErrorMessage.vue'

export default {
  name: 'TimeoutError',
  components: {
    ErrorMessage
  },
  props: {
    title: {
      type: String,
      default: 'Request Timed Out'
    },
    description: {
      type: String,
      default: 'The request took too long to complete. This might be due to a slow connection or server issues.'
    },
    showRetry: {
      type: Boolean,
      default: true
    },
    retryText: {
      type: String,
      default: 'Retry'
    }
  },
  emits: ['retry'],
  methods: {
    handleRetry() {
      this.$emit('retry')
    }
  }
}
</script>